import { useSessionStore } from "../../../stores/UserStore";
import { Stack } from "@mantine/core";
import {
  IconAddressBook,
  IconHelp,
  IconSettings,
  IconSpeakerphone,
  IconTimelineEvent,
} from "@tabler/icons-react";

export function getKnowledgesES() {
  const reseller = useSessionStore.getState().reseller;

  const result = [
    {
      url: "contact-lists",
      icon: IconAddressBook,
      title: "Listas de contactos",
      desc: "Todo sobre las listas de contactos",
      items: [
        {
          url: "filters",
          title: "Filtrar mis contactos en una lista",
          content: (
            <Stack>
              <p>
                Una vez creada tu lista, tendrás la posibilidad de ordenarla. Si
                no te conviene, o si deseas filtrarla, puedes excluir contactos.{" "}
                <br />
              </p>
              <p>
                En la página Contactos, puedes hacer clic en el nombre de tu
                lista y verás aparecer el detalle de tu lista.
                <br />
              </p>
              <p>
                Encontrarás un ícono “Filtros” encima de tu lista, que te
                permitirá excluir contactos de tu lista,
                <br />
              </p>
              <p>
                Por ejemplo: Deseo eliminar todos los contactos cuyo “cargo”
                contenga “Asistente”.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "page",
          title: "Funcionalidades de la página Contactos",
          content: (
            <Stack>
              <p>
                La pestaña Lista te permite encontrar el conjunto de tus listas
                de contactos para realizar tus campañas de prospección.
                <br />
                <br />
              </p>
              <p>
                Allí encontrarás todas las funcionalidades y herramientas para
                una buena gestión de tus listas de contactos
                <br />
              </p>
              <ul>
                <li>
                  Creación de lista desde nuestra base de contactos B2B
                  <br />
                </li>
                <li>Creación de lista desde LinkedIn</li>
                <li>Creación de tus listas desde Google</li>
                <li>Importación de tus listas</li>
              </ul>

              {/* Image here */}

              <p>
                <b>
                  VISTA DE CARPETAS
                  <br />
                </b>
              </p>
              <ul>
                <li>
                  Mostrar todas las listas
                  <br />
                </li>
                <li>Crear una carpeta</li>
                <li>Renombrar una carpeta</li>
                <li>Eliminar una carpeta</li>
                <li>Buscar una carpeta</li>
              </ul>
              <p>
                <b>
                  <br />
                  COLUMNA ''ACCIÓN''
                  <br />
                  Botón ''Lápiz'' puedes:
                </b>
              </p>
              <ul>
                <li>Renombrar tu lista</li>
                <li>Añadir Etiquetas</li>
                <li>Crear y mover tu lista a una carpeta</li>
              </ul>
              <p>
                <br />
              </p>
              <p></p>
              <p>
                <b>Botón ''+'' podrás:</b>
                <br />
              </p>
              <ul>
                <li>Ver los contactos de tu lista en una nueva pestaña</li>
                <li>Importar una lista de contactos desde un archivo</li>
                <li>Importar una lista de contactos copiando y pegando</li>
                <li>Descargar tu archivo en CSV o XLSX</li>
                <li>Duplicar tu lista</li>
                <li>Copiar una lista a un usuario, un equipo, una empresa</li>
                <li>Copiar tu lista al PRM</li>
                <li>Dividir tu lista en X listas (splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Botón ''Papelera''</b>
                <br />
              </p>
              <ul>
                <li>Eliminar tu lista</li>
              </ul>
              <p>
                <br />
                <b>INFO </b>: Puedes seleccionar varias listas para realizar
                simultáneamente una de las acciones
              </p>

              {/* Image here */}

              <p>
                <b>COLUMNA "ACCIÓN"</b>
              </p>
              <ul>
                <li>Descargar tus contactos en CSV o XLSX</li>
                <li>
                  Duplicar la selección de tus contactos en una nueva lista
                </li>
                <li>Copiar una lista a un usuario, un equipo, una empresa</li>
                <li>
                  Copiar la selección de tus contactos a un usuario, un equipo,
                  una empresa
                </li>
                <li>Copiar la selección de tus contactos al PRM</li>
                <li>
                  Dividir la selección de tus contactos en X listas (splitter)
                </li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>Botón ''Papelera''</b>
              </p>
              <ul>
                <li> Eliminar tu lista</li>
              </ul>
              <p></p>
              <p></p>

              {/* Image here */}

              <p>
                <b>
                  Barra de herramientas de acceso rápido
                  <br />
                </b>
              </p>
              <ul>
                <li>Buscar en una lista o carpetas</li>
                <li>Filtro de búsqueda multicriterio con condiciones</li>
                <li>Gestión de la visualización de columnas</li>
                <li>Exportar una lista o carpeta</li>
                <li>Eliminar una lista o carpeta</li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "configurations",
      icon: IconSettings,
      title: "Configuraciones",
      desc: "Configurar el software de prospección",
      items: [
        {
          url: "add-exclusions",
          title: "Crear tus listas de bajas o Blacklists",
          content: (
            <Stack>
              <p>
                En la plataforma, tienes la posibilidad de excluir contactos de
                tus campañas.
                <br />
                <br />
                Así no recibirán tus mensajes y serán excluidos automáticamente
                de tus campañas / escenarios.
                <br />
                <br />{" "}
              </p>
              <p>
                Es un principio de precaución para no contactar a tus
                prospectos, clientes, socios, proveedores, etc... sin tener que
                revisar manualmente cada contacto de tu lista antes de enviar tu
                campaña.
                <br />
                <br />
              </p>
              <p>Para ello, basta con:</p>
              <p>
                {" "}
                Importar una lista de contactos en formato CSV aquí{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/blacklists`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/blacklists.
                  <br />
                </a>
                O hacer clic en la pestaña “Configuración” &gt; “Blacklist” &gt;
                “Importar” una lista de contactos a excluir. <br />
                <br />
                También puedes crear carpetas de tus listas a excluir por tipo
                de exclusión como tus clientes, las personas a no contactar
                nunca...
                <br />
                <br />
              </p>
              <p>
                Las claves de baja tenidas en cuenta por el sistema son: el
                email, el nombre de dominio, el SIRET, el SIREN, el enlace de
                LinkedIn o la razón social.
                <br />
                <br />
              </p>
              <p>
                <b>Para dar de baja definitivamente a contactos</b>, Debes ir a
                esta página:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/unsubscribers`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/unsubscribers
                </a>{" "}
                .<br />
                O hacer clic en la pestaña “Configuración” &gt; “Lista de bajas”
                <br />
                <br />
              </p>
              <p>
                <b>Atención</b>: El archivo debe contener una sola información
                por línea. <br />
                Estas informaciones pueden estar mezcladas en tu archivo de
                importación.
                <br />
                <b>
                  <br />
                </b>
              </p>
              <p>
                <b>
                  La diferencia entre una lista de exclusión y una baja:
                  <br />
                  <br />
                </b>
              </p>
              <p>
                {" "}
                <b>La baja </b>es automática e irreversible: Una vez que el
                contacto está marcado como dado de baja, puedes estar seguro de
                que no recibirá nada más de tu parte.
                <br />
                <br />
              </p>
              <p>
                {" "}
                <b>La base de exclusión</b> se selecciona en cada campaña en
                función de tu voluntad o no de tenerla en cuenta en cada envío.
              </p>
            </Stack>
          ),
        },
        {
          url: "connect-email",
          title: "Conectar mi cuenta de e-mail",
          content: (
            <Stack>
              <p>
                Antes de lanzar una campaña de e-mail, hay que prestar atención
                al método de envío y al e-mail remitente elegido.
              </p>
              <p>Tendrás así dos alternativas:</p>
              <ol>
                <li>
                  {" "}
                  Envío masivo (mass mailing): esto permite enviar campañas a
                  grandes volúmenes y rápidamente, pero con una tasa de apertura
                  menos importante.
                  <br />
                  Los envíos (enrutamiento) se realizan a través de la
                  plataforma
                  {reseller?.name}. Tienes la posibilidad de configurar un alias
                  durante el envío. Un alias (artefacto) es el mail que verán
                  tus prospectos, pero que no se utilizará durante los envíos.
                  <br />
                  <b>Atención</b>, {reseller?.name} nunca aparecerá durante tus
                  envíos masivos
                </li>
                <li>
                  {" "}
                  Envío desde tu buzón de e-mail: Esto permite aumentar tus
                  tasas de respuesta al comunicarte con cada prospecto a un
                  nivel individual.
                </li>
              </ol>
              <p>
                {" "}
                Puedes conectar tus buzones de e-mail a la plataforma. Podrás
                ver, durante el envío de la campaña, los e-mails enviados en tu
                pestaña «E-mails enviados» en tu buzón de correo.{" "}
              </p>
              <p>
                Atención, te recomendamos limitar los envíos a 100 e-mails / día
                por e-mail remitente.
                <br />
                <br />
              </p>
              <p>
                <b>
                  Para configurar tus e-mails, te invitamos a hacer clic en el
                  enlace:{" "}
                </b>
              </p>
              <p>
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/senders/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /senders/email
                </a>{" "}
                o ir a la pestaña ‘’Herramienta’’ &gt; Emails remitentes
              </p>
              <p>Tendrás dos posibilidades:</p>
              <ol>
                <li>
                  {" "}
                  Haz clic en ‘’Añade tu email como remitente’’ (botón azul) que
                  corresponde a añadir un alias de envío masivo.
                  <br />- Introduce tu e-mail y luego valida en ''Guardar''.
                  Recibirás un e-mail de validación en tu buzón para asegurarnos
                  de que el dominio te pertenece.
                </li>
                <li>
                  {" "}
                  Haz clic en “Enviar tu e-mail desde tu dominio SMTP’’ (botón
                  verde) que corresponde a la conexión de tu buzón de correo.
                </li>
              </ol>
              <p>
                {" "}
                Al abrirse el pop-up, selecciona el proveedor de tu cuenta de
                e-mail
              </p>
              <ul>
                <li>
                  Para Gmail o Outlook, selecciona la dirección de e-mail que
                  deseas añadir y sigue los pasos siguientes.
                </li>
                <li>
                  Para otros proveedores de e-mail, rellena la información
                  solicitada.
                  <br />
                  <br />
                </li>
              </ul>
              <p>
                <b>Configuración complementaria:</b>
              </p>
              <p>
                Estas opciones te permitirán optimizar la buena recepción de tus
                e-mails:
              </p>
              <ul>
                <li> Activar / Desactivar el enlace de baja.</li>
                <li>
                  {" "}
                  Activar / Desactivar el seguimiento de abridores/clics.
                </li>
                <li>
                  {" "}
                  Frecuencias de envío: Lapso de tiempo entre dos envíos de un
                  e-mail.
                </li>
                <li>
                  {" "}
                  Warm UP: Calentamiento de un e-mail (técnica de preservación
                  de la reputación IP).
                </li>
                <li>
                  {" "}
                  Pool SMTP: Poder vincular tus e-mails remitentes a un pool
                  SMTP.
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "email-validation",
          title: "Validación de un E-mail",
          content: (
            <Stack>
              <p>
                <i>
                  <b>Pregunta </b>: He recibido el mail de validación de añadir
                  una cuenta de E-mail proveniente de:{" "}
                  <a
                    href={`http://${
                      reseller?.domain_saas3 || reseller?.domain_saas2
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {reseller?.domain_saas3 || reseller?.domain_saas2}
                  </a>{" "}
                  info@{reseller?.domain_saas3 || reseller?.domain_saas2} lo que
                  me parece anormal.
                </i>
              </p>
              <br />
              <p>
                <b>Respuesta </b>: No es un error, ya que la validación de una
                nueva cuenta (procedimiento del sistema) proviene de la
                plataforma <b>{reseller?.name}</b>.<br />
              </p>
              <p>
                Para disponer de un remitente personalizado para las alertas o
                las validaciones del software, hay que cambiar de plan para
                pasar a Marca Blanca.
                <br />
              </p>
              <p>Por favor, contacta al servicio comercial sobre este tema</p>
            </Stack>
          ),
        },
        {
          url: "create-signature",
          title: "Crear tus firmas de e-mail",
          content: (
            <Stack>
              <p>
                Cuando creas un e-mail, puedes añadir al contenido tu firma.{" "}
                <br />
              </p>
              <p>
                Para hacer esto, puedes importar previamente en la plataforma tu
                firma.
              </p>
              <p>
                Haz clic en el enlace{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email-signature`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email-signature
                </a>{" "}
                y luego haz clic en el botón ‘’Crear una firma’’
              </p>
              <p>
                O ve a la pestaña “Configuraciones” &gt; Firmas de E-mails.
                <br />
              </p>
              <p>
                Una vez añadida tu firma, cuando modifiques o crees tu plantilla
                de escenario, puedes hacer clic en el botón ''Firma'' para
                añadir tu firma eligiendo una de las firmas ya creadas. <br />
                <br />
              </p>
              <p>
                <b>INFO </b>: Durante la creación de tus mensajes de e-mails,
                podrás previsualizar tu mensaje con la firma deseada
              </p>
              <p></p>
            </Stack>
          ),
        },
        {
          url: "dynamic-columns",
          title: "Columnas dinámicas",
          content: (
            <Stack>
              <p>
                Las columnas dinámicas se utilizan durante una importación de
                una lista de contactos y cuando las columnas en tu archivo no
                han sido previstas y creadas por el software.
              </p>

              {/* Image here */}

              <p>
                Para paliar esta falta de columnas, durante la importación de tu
                archivo, tienes la posibilidad de crear estas columnas
                dinámicas.
                <br />
                <br />
              </p>
              <p>
                Para la gestión de estas columnas: añadir o eliminar, puedes ir
                aquí:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/settings/tools/datafields`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /settings/tools/datafields
                </a>
              </p>
              <p>
                O en la pestaña ''Configuraciones'' -&gt; columnas dinámicas
              </p>
              <p>
                <br />
                En la columna ''<b>Acción</b>'', puedes:{" "}
              </p>
              <p>
                <b>Eliminar </b>: permite eliminar la columna dinámica.
              </p>
              <p>
                <br />
                <b>ATENCIÓN </b>: Esta acción de eliminar una columna dinámica
                también eliminará <b>TODOS LOS DATOS</b> de esta columna <br />
                <br />
                La columna ''<b>Compartir</b>'' te permite compartir esta
                columna con tus colaboradores, un equipo o una empresa.
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "campaigns",
      icon: IconSpeakerphone,
      title: "Campañas",
      desc: "Lo básico sobre tus envíos de campañas",
      items: [
        {
          url: "statistics",
          title: "Estadísticas de tus campañas",
          content: (
            <Stack>
              <p>
                En la plataforma {reseller?.name}, dispones de las estadísticas
                de tus campañas.
                <br />
              </p>
              <p>
                En tu dashboard encontrarás el número de emails enviados, emails
                programados, emails clicados, emails abiertos, emails recibidos.
                <br />
              </p>
              <p>
                Para las campañas de LinkedIn, los KPIs a seguir serán las tasas
                de aceptación de tus invitaciones (nivel de relación 1), las
                tasas de respuesta y las tasas de lectura de tus mensajes (nivel
                de relación 2 y 3).
                <br />
              </p>
              <p>
                Los datos se reproducen en forma de tabla: así tienes las
                estadísticas que analizan tus campañas organizadas campaña por
                campaña.
                <br />
              </p>
              <p>
                Haz clic en el enlace:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/statistics/campaigns`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /statistics/campaigns
                </a>
              </p>
              <p>O ve a la pestaña ‘’Campañas’’</p>
              <p>
                <br />
                <b>En la tabla encontrarás:</b>
              </p>
              <ul>
                <li>
                  {" "}
                  Los emails programados: el número de emails que están en curso
                  de ejecución.
                </li>
                <li>
                  {" "}
                  El número de emails enviados a partir de los emails
                  programados.
                </li>
                <li>
                  {" "}
                  Los emails abiertos: El número de emails abiertos tras su
                  recepción.
                </li>
                <li>
                  {" "}
                  Los emails clicados: el número de emails donde hay un enlace
                  en el que el receptor ha hecho clic.
                </li>
                <li>
                  {" "}
                  El número de respuestas recibidas tras el envío de los emails.
                </li>
              </ul>
              <p>
                <br />
                Si deseas más detalles y acceder a las estadísticas de envío
                diarias, puedes hacer clic en el ícono “Informe” a la derecha de
                cada una de tus campañas en la pestaña de estadísticas.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "view-campaigns",
          title: "Encontrar mis campañas programadas",
          disabled: true,
          content: (
            <Stack>
              <p>
                Tienes la posibilidad de ver todas tus campañas una vez que
                están programadas haciendo clic en la pestaña “Campañas”:
                <br />
              </p>
              <p>
                Puedes filtrar rápidamente tus campañas eligiendo “En curso, En
                pausa, Error, Archivado''
                <br />
                <br />
                También puedes utilizar los filtros multicriterio mediante la
                función ''Filtros''
                <br />
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "leads-tracking",
      icon: IconAddressBook,
      title: "Seguimiento de leads",
      desc: "Gestión de la Relación con Prospectos",
      items: [
        {
          url: "general",
          title: "Seguimiento de leads en general",
          disabled: true,
          content: (
            <Stack>
              <p>
                Para cada campaña enviada, el sistema crea una carpeta en la
                plataforma en la que almacena tus contactos activos: es el PRM
                (Gestión de la Relación con Prospectos).
                <br />
              </p>
              <p>
                No se gestiona un PRM como se gestiona un CRM (Gestión de la
                Relación con Clientes).
                <br />
              </p>
              <p>
                Por una razón bastante simple de entender: un cliente, no es un
                prospecto y no nos dirigimos de la misma manera a un cliente que
                a un prospecto.
                <br />
              </p>
              <p>
                ¡Los enfoques relacionales y las acciones que de ellos se
                derivan son diferentes!
              </p>
              <p>
                A diferencia de un CRM, el PRM permite automatizar tareas de
                seguimiento a través del escenario, orientar al prospecto hacia
                nuevos bucles de prospección, activar el nurturing en función de
                su estado: interesado, aún no listo...
                <br />
              </p>
              <p>
                Así, en cada carpeta, encontrarás los prospectos de cada campaña
                de forma independiente: los que abrieron, los que hicieron clic,
                los que respondieron, las personas que aceptaron tu invitación
                de LinkedIn, las personas que te respondieron en LinkedIn, etc.
                <br />
              </p>
              <p>
                El PRM es accesible en{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/leads-tracking`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /leads-tracking
                </a>{" "}
              </p>
              <p>
                o por la pestaña “PRM”.
                <br />
              </p>
              <p>
                En cada carpeta PRM, encontrarás así tus contactos activos,
                clasificados por estado y por orden de scoring decreciente.
                <br />
              </p>
              <p>
                También puedes sincronizar automáticamente en tu CRM después de
                haber creado una sincronización con {reseller?.name} o descargar
                tus contactos activos y trabajarlos directamente en tu CRM
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "workflows",
      icon: IconTimelineEvent,
      title: "Escenario",
      desc: "Todo sobre los escenarios",
      items: [
        {
          url: "create-email",
          title: "Crear un escenario",
          content: (
            <Stack>
              <p>
                En la plataforma puedes crear escenarios que representan una
                sucesión de acciones desencadenadas bajo condiciones
                predefinidas.
                <br />
                <br />
              </p>
              <p>
                Para crear un nuevo escenario, te invitamos a ir a este enlace:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/campaign/create`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /campaign/create
                  <br />
                  <br />
                </a>
              </p>
              <p>
                O ve a la pestaña “Mis escenarios” &gt; Crear un nuevo escenario
                &gt; Añadir un nombre de escenario.
                <br />
                <br />
              </p>
              <p>Este es el procedimiento a seguir para crear un escenario:</p>
              <ol>
                <li>
                  Elige el canal que desees entre LinkedIn / Email / SMS /
                  Mensaje de voz.
                </li>
                <li>
                  {" "}
                  Primer mensaje: Añade tu mensaje de prospección a tu árbol de
                  escenario haciendo clic en el pequeño más debajo de la acción
                  inicial.
                </li>
                <li>
                  {" "}
                  Seguimiento: Elige el canal por el que deseas hacer el
                  seguimiento.
                </li>
                <li>
                  {" "}
                  Selecciona la población que recibirá tu seguimiento (los que
                  abrieron, los que hicieron clic, no activos, personas que
                  aceptaron tu invitación en LinkedIn, etc.) y el plazo en el
                  que partirá tu seguimiento.
                </li>
                <li> Añade los contenidos de tus mensajes de seguimiento.</li>
                <li>
                  {" "}
                  Guarda tu escenario.
                  <br />
                  <br />
                </li>
              </ol>
              <p>
                <b>Atención</b>, asegúrate de haber creado previamente tus
                diferentes mensajes en el enlace:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>{" "}
                o yendo a la pestaña ‘’Mis plantillas de emails’’
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "faq-guides-questions",
      icon: IconHelp,
      title: "FAQ, GUÍAS Y PREGUNTAS",
      desc: "Preguntas frecuentes sobre la aplicación",
      items: [
        {
          url: "smtp-limit",
          title: "Límite SMTP alcanzado",
          content: (
            <Stack>
              <p>
                <b>Pregunta </b>:{" "}
                <i>
                  Estoy intentando introducir nuevos emails remitentes, y cuando
                  llego al final de la introducción me aparece un mensaje de
                  error que dice: LÍMITE SMTP alcanzado
                </i>
              </p>

              <br />
              <p>
                <b>Respuesta </b>: Has alcanzado el límite del número de cuentas
                a integrar en el software.
              </p>
              <p>
                Debes verificar el límite del número de cuentas de tu oferta.
                <br />
              </p>
              <p>
                Si deseas disponer de más cuentas SMTP, por favor pasa a una
                oferta superior
              </p>
            </Stack>
          ),
        },
        {
          url: "edit-sender-name",
          title: "¿Cómo modificar el nombre del remitente?",
          content: (
            <Stack>
              <p>
                <b>Pregunta </b>:{" "}
                <i>
                  Cuando un prospecto responde a un mail, recibo este mail de
                  ''Nicolas de {reseller?.name}''. ¿Cómo modificar el nombre del
                  remitente?
                </i>
              </p>
              <br />
              <p>
                <b>Respuesta </b>: Cuando creas/modificas tu email aquí:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>
                <br />
                <br />
              </p>
              <p>
                A la derecha del campo «e-mail de respuesta» tienes un «+» que
                te permite elegir la opción de la respuesta
                <br />
              </p>
              <ol>
                <li>
                  ==&gt; Opción 01: Recibes el e-mail en directo como si tu
                  prospecto te respondiera directamente sin que la respuesta
                  pase por nuestra plataforma. En ese momento, ya no tendrás los
                  problemas reportados, pero no podremos guardar la respuesta
                  recibida dentro de nuestra plataforma
                  <br />
                  <br />
                </li>
                <li>
                  ==&gt; Opción 02: (la seleccionada por el momento) Cuando el
                  prospecto responde, responde a nuestro servidor que te
                  retransmite el e-mail, es la razón por la cual ves aparecer
                  «Nicolas de {reseller?.name}». Esta solución nos permite
                  guardar la respuesta del prospecto dentro de la plataforma.
                  <br />
                  <br />
                </li>
              </ol>
              Con esta solución, una vez que recibes la respuesta, es mejor
              abrir una nueva conversación para continuar el intercambio con tu
              prospecto.
            </Stack>
          ),
        },
        {
          url: "checkout-failed",
          title: "¿Por qué falla mi pago con tarjeta?",
          content: (
            <Stack>
              <p>
                Utilizamos un sistema de pago seguro (3D secure) aprobado por la
                ACPR, bajo el número 16568 para proteger tus compras.
                <br />
                <br />
              </p>
              <p>
                Verifica la recepción de un SMS para validar tu compra. <br />
                Si el problema persiste, contáctanos.
              </p>
            </Stack>
          ),
        },
        {
          url: "segment-contact-list",
          title: "¿Es posible segmentar mis listas de contactos?",
          content: (
            <Stack>
              <p>
                <b>Sí, </b>creando tantas listas de contactos de prospección
                como desees.
                <br />
                <br />
              </p>
              <p>
                Gracias a nuestros filtros inteligentes, puedes combinar los
                filtros de búsqueda: Cargo, sector de actividad, código NAF,
                Plantilla, Cifra de negocios, tratamiento, centro de interés,
                centro de competencias…
                <br />
                <br />
              </p>
              <p>
                Si te falta un filtro entre nuestros 20 filtros, no dudes en
                pedírnoslo.
              </p>
            </Stack>
          ),
        },
        {
          url: "database-reactive",
          title: "¿Vuestra base de contactos es reactiva?",
          content: (
            <Stack>
              <p>
                <b>Sí</b>, porque nuestras bases se prueban durante el envío de
                emailings para nuestros clientes.
                <br />
              </p>
              <p>
                Gracias a los rastreadores que ponemos en nuestros mails durante
                el envío, nos es posible controlar si el prospecto abre su buzón
                de e-mail.
                <br />
              </p>
              <p>
                Si un prospecto no abre su buzón de correo en el mes, ponemos en
                aislamiento a este contacto para no prospectarlo más.
                <br />
              </p>
              <p>
                Lo que nos permite disponer de una base de contactos B2B
                reactiva.
                <br />
              </p>
            </Stack>
          ),
        },
        {
          url: "is-it-french",
          title: "¿Vuestra solución está desarrollada en Francia?",
          content: (
            <Stack>
              <p>
                <b>Sí</b>, nuestra solución es 100% Francesa
                <br />
              </p>
              <ul>
                <li> Está desarrollada en Francia</li>
                <li>
                  {" "}
                  Está alojada en servidores seguros y en Francia por OVH
                </li>
                <li>
                  {" "}
                  Todos los datos de {reseller?.name} y de nuestros clientes
                  serán almacenados en servidores seguros en Francia
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "what-is-your-data-sources",
          title: "¿Cuáles son las fuentes de vuestros archivos",
          content: (
            <Stack>
              <p>
                Las principales fuentes de nuestra base de datos profesionales
                B2B provienen de archivos ya constituidos por directorios
                profesionales especializados y líderes en sus dominios:
                <br />
              </p>
              <ul>
                <li> Los datos públicos de las redes sociales</li>
                <li>
                  {" "}
                  La base de datos de información legal del INSEE, Infogreffe,
                  el Bodacc, Legi France, RNCS…
                </li>
                <li>
                  {" "}
                  De la CCI: El portal de las Cámaras de Comercio e Industria
                </li>
                <li> El directorio oficial de artesanos</li>
                <li>
                  {" "}
                  Los directorios de libre acceso: Vérif.com, Societe.com,{" "}
                  <a
                    href={`http://Kompass.fr`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kompass.fr
                  </a>{" "}
                  …
                </li>
                <li>
                  {" "}
                  Los archivos en OpenData de las administraciones públicas, de
                  la salud, de la educación, de las asociaciones…
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "database-constitution",
          title: "¿Cómo está constituida vuestra base de contactos B2B?",
          content: (
            <Stack>
              <p>
                Gracias a nuestros scripts y nuestros algoritmos inteligentes,
                agregamos todos
              </p>
              <p>
                los días más de 20 fuentes de archivos de profesionales
                cualificados.
                <br />
              </p>
              <p>
                Los perfiles de nuestra base B2B son estructurados, fusionados y
                enriquecidos y reverificados cotidianamente.
              </p>
            </Stack>
          ),
        },
        {
          url: "does-it-follow-rgpd-guidelines",
          title: "¿Vuestra solución es conforme a la reglamentación RGPD?",
          content: (
            <Stack>
              <p>
                <b>Sí</b>, nuestra solución es conforme al RGPD (Reglamento
                General sobre la Protección de Datos Personales).
                <br />
              </p>
              <p>
                Se trata de un reglamento adoptado por el parlamento europeo el
                14 de abril de 2016 y que entró en vigor en la Unión Europea el
                24 de mayo de 2018.
                <br />
              </p>
              <ul>
                <li>
                  Nuestra base está constituida de informaciones que
                  recolectamos a partir de más de 20 fuentes de archivos de
                  profesionales cualificados y en Open-data así como datos
                  Insee, que agregamos y estructuramos a través de nuestros
                  algoritmos inteligentes.
                </li>
                <li>
                  {" "}
                  Solo trabajamos con datos B2B, no sometidos al consentimiento
                  previo como lo estipula el artículo 6 de la CNIL por la
                  directiva e-Privacy que prevalece sobre el RGPD, y transpuesto
                  al derecho francés.
                </li>
                <li>
                  {" "}
                  Respetamos la obligación de poner un enlace de baja en cada
                  campaña de nuestros clientes.
                </li>
                <li>
                  {" "}
                  Si el cliente olvida poner un enlace de desinscripción o está
                  mal escrito, entonces nuestro sistema lo detecta y añade
                  AUTOMÁTICAMENTE un enlace de desinscripción en claro al final
                  de la página.
                </li>
                <li>
                  {" "}
                  De informar al internauta de las informaciones que detentamos,
                  del origen de la recolección así como de la supresión de sus
                  informaciones que detentamos.
                </li>
                <li>
                  {" "}
                  También podemos excluir el mail, el dominio o el Número SIREN
                  de las empresas que lo soliciten para no prospectarlas más.
                </li>
                <li>
                  {" "}
                  Cada cliente podrá importar sus listas (cifrado MD5) de
                  contactos, dominios o SIREN a excluir de tus campañas.
                </li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
  ];

  if (reseller?.name === "Magileads") {
    result[0].items.unshift(
      {
        url: "import-linkedin",
        title: "Crear una lista a partir de LinkedIn",
        content: (
          <Stack>
            <p>
              Con {reseller?.name}, puedes crear listas de contactos a partir de
              una búsqueda en LinkedIn o Sales Navigator. Debes por lo tanto
              disponer de una cuenta de LinkedIn.
              <br />
            </p>
            <p>
              El principio es simple, a partir de tu cuenta de LinkedIn, haces
              una búsqueda de contactos en el sitio de LinkedIn y copias/pegas
              el enlace de tu búsqueda en la plataforma
              {reseller?.name}.
              <br />
            </p>
            <p>
              Así, el sistema creará una lista de contactos correspondientes a
              los perfiles que has segmentado en LinkedIn.
              <br />
            </p>
            <p>
              Para realizar la importación de tus contactos de LinkedIn, haz
              clic en el enlace:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin
              </a>{" "}
              luego haz clic en Búsqueda en LinkedIn
            </p>
            <p>O ve a la pestaña “Contacto“ &gt; Búsqueda en LinkedIn</p>
            <p>Tienes así varias posibilidades: </p>
            <b>
              {" "}
              Extraer contactos a partir de una búsqueda de LinkedIn/Sales
              Navigator siguiendo los pasos a continuación:
              <br />
            </b>
            <ol>
              <li> Realiza tu búsqueda en LinkedIn/Sales Navigator. </li>
              <li>
                {" "}
                Copia el enlace URL de la página de tu búsqueda en LinkedIn o
                Sales Navigator.
              </li>
              <li>
                {" "}
                Pega en la sección “URL de LinkedIn de la búsqueda” &gt;
                Siguiente.
              </li>
              <li>
                {" "}
                Elige el número de perfiles a extraer que deberá ser superior o
                igual al número de contactos encontrados al final de tu búsqueda
                &gt; Siguiente.
              </li>
              <li>
                {" "}
                Selecciona la cuenta de LinkedIn con la que deseas extraer los
                contactos &gt; Siguiente
              </li>
              <li> Da un nombre a tu lista.</li>
              <li>
                {" "}
                Marca la casilla enriquece mi lista si deseas obtener las
                direcciones de email profesionales de tus contactos. &gt;
                Siguiente. <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>Nota </b>: El sistema está importando tu lista, se necesitan 20
              minutos para extraer 2000 contactos, encontrarás tu lista en
              “Contactos”{" "}
            </p>
            <p>
              <b>
                Extraer contactos que han comentado/dado 'me gusta' a una
                publicación en LinkedIn siguiendo los pasos a continuación:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                En LinkedIn, una vez en la publicación de tu elección, haz clic
                en los 3 pequeños puntos en la parte superior derecha de la
                publicación y selecciona “Copiar enlace de la publicación”{" "}
              </li>
              <li>
                {" "}
                En {reseller?.name}, en “Contactos” luego “Segmentación” luego
                “Búsqueda en LinkedIn” selecciona “Extraer contactos que han
                comentado una publicación en LinkedIn” o “Extraer contactos que
                han dado 'me gusta' a una publicación en LinkedIn”
              </li>
              <li>
                {" "}
                Pega el enlace URL en la sección “URL de LinkedIn de la
                búsqueda”.
              </li>
              <li>
                {" "}
                Elige el número de perfiles a extraer que deberá ser superior o
                igual al número de contactos encontrados al final de tu búsqueda
                &gt; Siguiente.{" "}
              </li>
              <li>
                {" "}
                Selecciona la cuenta de LinkedIn con la que deseas extraer los
                contactos.&gt; Siguiente.
              </li>
              <li> Da un nombre a tu lista &gt; Siguiente</li>
              <li>
                {" "}
                Marca la casilla enriquece mi lista si deseas obtener las
                direcciones de email profesionales de tus contactos.
              </li>
              <li>
                {" "}
                El sistema importa tu lista, encontrarás tu lista en “Contactos”
                <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>
                Extraer contactos conectados a tu red de LinkedIn (nivel 1)
                siguiendo los pasos a continuación:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                En {reseller?.name}, en “Segmentación” luego “Búsqueda en
                LinkedIn” selecciona “Extraer tus conexiones en LinkedIn”
              </li>
              <li> Precisa el número de perfiles a importar </li>
              <li>
                {" "}
                Selecciona la cuenta de LinkedIn con la que deseas extraer los
                contactos.&gt; Siguiente
              </li>
              <li> Da un nombre a tu lista &gt; Siguiente</li>
              <li>
                {" "}
                Marca la casilla enriquece mi lista si deseas obtener las
                direcciones de email profesionales de tus contactos.
              </li>
              <li>
                {" "}
                El sistema importa tu lista, encontrarás tu lista en “Contactos”
              </li>
            </ol>
            <p>
              <b>
                Extraer los publicadores de ofertas de empleo en LinkedIn
                siguiendo los pasos a continuación:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Inicia tu búsqueda de empleo en LinkedIn seleccionando “empleos”
                en LinkedIn.
              </li>
              <li> Copia el enlace de tu búsqueda.</li>
              <li>
                {" "}
                Pega este enlace en {reseller?.name}, en “Segmentación” luego
                “Búsqueda en LinkedIn” luego “Extraer los publicadores de
                ofertas de empleo en LinkedIn”
              </li>
              <li>
                {" "}
                Elige el número de perfiles a extraer que deberá ser superior o
                igual al número de contactos encontrados al final de tu búsqueda
                &gt; Siguiente.{" "}
              </li>
              <li>
                {" "}
                Selecciona la cuenta de LinkedIn con la que deseas extraer los
                contactos.&gt; Siguiente
              </li>
              <li> Da un nombre a tu lista &gt; Siguiente</li>
              <li>
                {" "}
                Marca la casilla enriquece mi lista si deseas obtener las
                direcciones de email profesionales de tus contactos.
              </li>
              <li>
                {" "}
                El sistema importa tu lista, encontrarás tu lista en
                “Contactos”.
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-google",
        title: "Crear una lista a partir de Google Maps",
        content: (
          <Stack>
            <p>
              Con {reseller?.name}, a partir de tu cuenta de Google, puedes
              crear listas de contactos a partir de una búsqueda en Google Maps
              siguiendo los pasos a continuación:
            </p>
            <p>
              {" "}
              <br />
              Puedes crear una lista de contactos a partir de una búsqueda en
              Google Maps a través del siguiente enlace:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/google`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/google
              </a>{" "}
              <br />O ve a la pestaña “Segmentación &gt; Google”
            </p>
            <p>
              <br />
            </p>
            <ol>
              <li>
                Ve a Google Maps para hacer una búsqueda poniendo tus elementos
                de búsqueda, es decir, el cargo y la situación geográfica:
                Ejemplo Informática en París.{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/
                </a>{" "}
                <br /> <br />
              </li>
              <li>
                {" "}
                En la barra de búsqueda de tu navegador, copia el enlace URL de
                la página de tu búsqueda de Google Maps. Ejemplo:{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu
                </a>
                <br />
              </li>
              <li>
                {" "}
                Pega el enlace URL en {reseller?.name} en la pestaña
                “Segmentación &gt; Google” para extraer los resultados de una
                búsqueda en Google Maps.
                <br />
              </li>
              <li>
                Selecciona tu cuenta de Google que has configurado. <br />
              </li>
              <li>
                {" "}
                Elige el número de resultados / perfiles a extraer.
                <br />
              </li>
              <li>
                {" "}
                Da un nombre a tu lista para guardarla o selecciona la carpeta y
                una lista de contactos existente.
                <br />
                El sistema importará tu lista que encontrarás en la pestaña
                “Contactos”.
                <br />
                También puedes marcar la opción de enriquecimiento ''Enriquecer
                base fuera de Francia'' de tu lista para completarla con
                información legal y añadir los mails para listas extranjeras{" "}
                <br />
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-database",
        title: "Crear una lista a partir de la base de contactos",
        content: (
          <Stack>
            <p>
              Tienes la posibilidad en la plataforma de crear una lista de
              contactos a partir de nuestra base de varios millones de contactos
              BtoB.
              <br />
            </p>
            <p>
              Para crear una lista de contactos a partir de nuestra base de
              datos haciendo clic en el siguiente enlace:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/base`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/base
              </a>{" "}
              <br />
            </p>
            <p>
              O ve a la pestaña <b>Segmentación</b>
            </p>
            <ul>
              <li>
                Tienes así la posibilidad de afinar tu búsqueda añadiendo más
                criterios como el cargo, el dominio de actividad e incluso la
                zona geográfica.
              </li>
              <li>
                También puedes filtrar tu lista precisando el código NAF, la
                actividad de la empresa, su cifra de negocios, su forma
                jurídica, su presencia en la web: Haz clic cada vez en la flecha
                azul al lado de cada filtro para añadir tu elección.
              </li>
            </ul>
            <p>
              <br />
              Para guardar los contactos encontrados en tu lista, Haz clic en el
              botón “guardar” a la derecha de los perfiles que aparecen.
              <br />
            </p>
            <p>
              <b>Nota </b>: tienes la posibilidad de crear o añadir estos
              contactos a una lista ya creada.
              <br />
            </p>
            <p>
              Tu lista se añade así en haciendo clic en el siguiente enlace:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists
              </a>{" "}
            </p>
            <p>
              O ve a la página <b>Contactos</b>
            </p>
          </Stack>
        ),
      },
      {
        url: "linkedin-import-not-working",
        title: "La importación de contactos de LinkedIn no funciona",
        content: (
          <Stack>
            <p>
              Si tu importación de LinkedIn no funciona, puedes verificar estos
              puntos:
            </p>
            <p>
              <br />
              1.Ve a{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/senders/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /senders/linkedin
              </a>
            </p>
            <p>O en “Configuraciones” luego “Cuentas de LinkedIn” </p>
            <ul>
              <li>
                Verifica que tu cuenta sigue conectada
                <br />
                Si no, actualiza la cookie de conexión
                <br />
              </li>
            </ul>
            <p></p>
            <p>
              2. Ve a{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin <br />
              </a>
            </p>
            <p>
              O en ''Segmentación'' &gt; ''LinkedIn''
              <br />
            </p>
            <ul>
              <li>
                <b>A</b> : Verifica que el enlace importado es compatible con la
                naturaleza de tu cuenta de LinkedIn (una cuenta que no es Sales
                Navigator no puede importar un enlace de Sales Navigator)
                <br />
              </li>
            </ul>
            <ul>
              <li>
                <b>B</b> : Verifica que el formato del enlace es el solicitado
                por el sistema al crear la lista
              </li>
            </ul>
            <p></p>
            <p>
              Si tu importación sigue sin funcionar, no dudes en solicitarnos,
              ¡estamos aquí para ayudarte!
            </p>
          </Stack>
        ),
      }
    );
    result[5].items.push({
      url: "cname-error",
      title: "Mensajes de error CNAME",
      content: (
        <Stack>
          <p>
            <b>Pregunta </b>: Tengo este mensaje de error cuando quiero acceder
            a mi marca blanca
          </p>
          <p>{`{"state":false,"state_message":"action_not_exist","documentation":null}`}</p>
          <p>
            <br />
          </p>
          <p>
            <b>Respuesta </b>: Quizás no has rellenado bien los parámetros en el
            software o en la redirección CNAME de tu dominio.
            <br />
            Este problema proviene siempre de un error de configuración.
          </p>
          <p>
            <br />
            <b>Consultar los registros CNAME con tu proveedor de dominio</b>
          </p>
          <ul>
            <li>
              Subdominio mail escrito en tu dominio CNAME
              <br />
              <br />
              <b>Consultar los parámetros en el software</b>
              <br />
            </li>
            <li>Error al escribir el nombre de dominio en el software</li>
          </ul>
          <p>
            <br />
          </p>
          <p>
            Solución de verificación: Ejecutar <b>nslookup </b>en tu ordenador
            <br />
            <br />
          </p>
          <p>
            La aplicación nslookup está disponible en la mayoría de los sistemas
            operativos. <br />
            Permite buscar la información concerniente a los servidores de
            nombres utilizando una línea de comandos bajo Microsoft Windows,
            Apple Mac o Linux.
            <br />
            <br />
            Para ejecutar la línea de comandos bajo Windows, haz clic en Inicio
            &gt; Ejecutar.
          </p>
          <ul>
            <li>Escribe cmd, y luego presiona Intro.</li>
            <li> Bajo Mac o Linux, inicia el terminal.</li>
            <li> Escribe el siguiente comando:</li>
            <li>
              {" "}
              nslookup -q=cname{" "}
              <a href={`saas.example.com`} target="_blank" rel="noreferrer">
                saas.example.com
              </a>{" "}
            </li>
            <li>
              {" "}
              Reemplaza{" "}
              <a href={`http://example.com`} target="_blank" rel="noreferrer">
                example.com
              </a>{" "}
              por el nombre del dominio que contiene el registro CNAME que
              deseas consultar.
              <br />
              <br />
            </li>
          </ul>
          <p>
            {" "}
            Interpreta el resultado como en el siguiente ejemplo,{" "}
            <a href={`example.com`} target="_blank" rel="noreferrer">
              example.com
            </a>{" "}
            :
          </p>
          <p>
            {" "}
            nslookup -q=cname <a href={`saas.exemple.com`}>saas.exemple.com</a>
          </p>
          <p>
            {" "}
            <br />
            Con este ejemplo, obtenemos los siguientes datos:
          </p>
          <p> Server: box </p>
          <p> Address: 192.168.1.1</p>
          <p> Respuesta no autoritativa:</p>
          <p>
            {" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>
            canonical name =
            <a
              href={`resellers-pool1.staging.magileads.net`}
              target="_blank"
              rel="noreferrer"
            >
              resellers-pool1.staging.magileads.net
            </a>
            .
          </p>
          <p>
            {" "}
            <br />
            La información buscada figura en las dos últimas líneas. <br />
            Más precisamente, el resultado nos indica que{" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>{" "}
            apunta al nombre r
            <a
              href={`resellers-pool1.staging.magileads.net.`}
              target="_blank"
              rel="noreferrer"
            >
              esellers-pool1.staging.magileads.net.
            </a>
          </p>
          <p>
            <br />
          </p>
          <p>
            También puedes probar tus subdominios en este enlace si conoces la
            IP de tu proveedor de hosting:{" "}
            <a
              href={`https://www.saas-secure.com/online-services/nslookup.html`}
              target="_blank"
              rel="noreferrer"
            >
              https://www.saas-secure.com/online-services/nslookup.html
            </a>
          </p>
          <p>
            <br />
          </p>
          <p></p>
        </Stack>
      ),
    });
  }

  return result;
}
